export default "__VITE_ASSET__TztAhTTO__"